import { useState, useRef, useEffect } from "react";
 
function useVisible(initialVisible) {
  const [visible, setVisible] = useState(initialVisible);
  const ref = useRef(null);
 
  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
        setVisible(false);
    }
  };
 
  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);
 
  return { ref, visible, setVisible };
}
 
export default useVisible;